import { Box, Tooltip } from '@mui/material'

export const renderMarketFilter = (value: JSX.Element[]) => {
  if (Array.isArray(value)) {
    const isMore = value.length > 1

    const content = (
      <Box display="flex" gap={1} alignItems="center">
        {value.slice(0, 1).map((el, idx) => (
          <div key={`market-filter-${idx}`}>{el}</div>
        ))}
        {isMore && `+${value.length - 1}`}
      </Box>
    )

    return isMore ? (
      <Tooltip
        title={
          <Box display="flex" gap={1} alignItems="center" flexDirection="column">
            {value.slice(1).map((el, idx) => (
              <div key={`market-filter-${idx}`}>{el}</div>
            ))}
          </Box>
        }
      >
        {content}
      </Tooltip>
    ) : (
      content
    )
  }
  return null
}
